import { Button, Flex, StarFilledIcon } from '@iheartjane/reefer';

import {
  useProductSearchFilters,
  useSearchParamFilter,
} from '@jane/bloom/hooks/filters';
import type { RatingSearchFilterFacet } from '@jane/bloom/viewModels/productSearchFilters';

import { ModalSection } from './modalSection';

import styles from './ratingSection.module.css';

function StarsIcon({ numStars }: { numStars: number }) {
  return (
    <Flex flexDirection="row">
      {Array.from({ length: numStars }, (_, i) => (
        <StarFilledIcon size="sm" key={i} />
      ))}
    </Flex>
  );
}

export function RatingSection() {
  const { clearFilter, getFilterOptionValue, getFilterStatus, setFilter } =
    useSearchParamFilter('ratings');

  const { getProductSearchFilterOptions } = useProductSearchFilters();

  const ratingFilters = getProductSearchFilterOptions(
    'ratings'
  ) as RatingSearchFilterFacet[];

  return (
    <ModalSection filterLabel="Rating" deselectFilters={clearFilter}>
      <div className={styles['ratings']}>
        {ratingFilters.map(({ count, start: i, value: filterValue }) => {
          return (
            <Button
              className={styles['ratingButton']}
              full
              size="large"
              variant={
                getFilterStatus(filterValue) === 'selected'
                  ? 'tertiary-selected'
                  : 'tertiary'
              }
              key={`stars-${i}`}
              startIcon={<StarsIcon numStars={i} />}
              label={`${i}+ (${count})`}
              disabled={count === 0}
              alignment="left"
              onClick={() => {
                setFilter(filterValue, !getFilterOptionValue(filterValue));
              }}
            />
          );
        })}
      </div>
    </ModalSection>
  );
}
